import { LoggingLevel, ILogger } from '@augloop/interfaces';
import { IOperationEvent, ISessionHealthEvent } from '@augloop/tracelogger';

import { DataCategories, DiagnosticLevel, IHostCallbacks } from './iclientruntime';

const US_PER_MS = 1e3;

export class TelemetryLogger implements ILogger {
    private static readonly augLoopAriaTenantToken = '3de4087d4de34817b1c376e3d1e6e293-983c4292-5ba9-485a-ab10-9797863c788b-6770';

    public level: LoggingLevel;
    private readonly hostCallbacks: IHostCallbacks;

    public constructor(hostCallbacks: IHostCallbacks) {
        this.level = LoggingLevel.info;
        this.hostCallbacks = hostCallbacks;
    }

    /* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
    public log(obj: any): void {
        if (this.hostCallbacks == null || this.hostCallbacks.sendTelemetryEvent == null) {
            return;
        }

        const logToHost = (op: IOperationEvent | ISessionHealthEvent, opName: string) => {
            const operationName = opName.charAt(0).toUpperCase() + opName.slice(1);
            this.hostCallbacks.sendTelemetryEvent(
                TelemetryLogger.augLoopAriaTenantToken,
                `Office_AugLoop_Client_${operationName}`,
                {
                    ResourceId: op.resourceId,
                    ResultDescription: op.resultDescription,
                    ResultSignature: op.resultSignature,
                    Dimension0: op.dimension0,
                    Dimension1: op.dimension1,
                    Dimension2: op.dimension2,
                    Dimension3: op.dimension3
                },
                'Office.System.Activity',
                {
                    CV: op.cv,
                    Duration: op.durationMs * US_PER_MS,
                    Count: op.count,
                    AggMode: 2/*OnSuccess*/,
                    Success: op.success
                },
                false/*critical*/,
                /* All AugLoop events currently log as Usage/Performance RSD */
                DataCategories.ProductServiceUsage | DataCategories.ProductServicePerformance,
                DiagnosticLevel.RequiredServiceDataEvent);
        };
        if (obj.eventName === 'Operation') {
            const op: IOperationEvent = obj;
            logToHost(op, op.operationName);
        } else if (obj.eventName === 'SessionHealth') {
            const she: ISessionHealthEvent = obj;
            logToHost(she, she.sessionHealthEventName);
        }
    }
}
